module.exports = __webpack_public_path__ + "img/04.015f4479.jpg";